/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Alert,
  Form,
  Button,
  Row,
  Col,
  Input,
  Spin,
  Card,
  Modal,
  Typography,
  DatePicker,
  Menu,
} from 'antd';
import {
  FileExcelOutlined,
} from '@ant-design/icons';
import { formatReceivedValues } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalErroresControls from 'components/ModalErroresControls';
import Select from 'components/Select';
import {
  getEstadosGlobales,
  getTiposDeNomina,
  getPeriodicidadesDePagos,
} from 'api/catalogos/index';
import { getSubtiposNominas } from 'api/nominas/subtiposDeNominas';
import { getEmpleadosWithoutFilter } from 'api/estructuraOrganizacional/empleados';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import {
  postCalculosDeNominas,
  getCalculoDeNomina,
  getNominasErrores,
} from 'api/nominas/calculosDeNominaEncabezado';
import { getEstatusTimbrado, getNominasTimbrables } from 'api/nominas/timbrado';
import { descargarExcel } from 'api/nominas/calculosDeNominas';
import { checkToken } from 'api/utils';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import EstatusTimbradoTag from 'components/Nominas/Timbrado/EstatusTimbradoTag';
import {
  SLUG_PATTERN,
} from 'utils/patterns';
import 'moment/locale/es';
import { getModelPermission } from 'utils/permission';
import moment from 'moment/moment';
import TimbradoNominaDetalle, { timbradoNominaDetallePermission } from './TimbradoNominasDetalle';

const { Text } = Typography;

export const timbradoNominaPermission = {
  permissionModel: 'nomina',
  catalogsModels: [],
  tabsModels: [],
};

const TimbradoNominas = ({ permission }) => {
  const modoPruebasTimbrado = useSelector(
    ({ auth }) => auth?.entidad?.configuracion?.modo_pruebas_timbrado,
  ) === true;
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [encabezado, setEncabezado] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodosNominas, setPeriodosNominas] = useState([]);
  const [periodosFiltered, setPeriodosFiltered] = useState([]);
  const [visibleErrores, setVisibleErrores] = useState(false);
  const [errores, setErrores] = useState([]);
  const [tiposDeNomina, setTiposDeNomina] = useState([]);
  const [periodicidades, setPeriodicidades] = useState([]);
  const [periodo, setPeriodo] = useState();
  const [subtiposDeNomina, setSubtiposDeNomina] = useState([]);
  const [aplicaRetroactivo, setAplicaRetroactivo] = useState(false);
  const [aplicaCalculoPorEmpleado, setAplicaCalculoPorEmpleado] = useState(false);
  const [empleadosDisponibles, setEmpleadosDisponibles] = useState([]);
  const [estatusTimbrado, setEstatusTimbrado] = useState([]);

  // Fechas de timbrado (DateTimeField): llegan como Moment tras formatReceivedValues
  const formatearFechaHoraTimbrado = (valor) => {
    if (!valor) return '—';
    const fecha = moment(valor);
    return fecha.isValid() ? fecha.format('DD/MM/YYYY HH:mm:ss') : '—';
  };

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        tipo_de_nomina_empleado_periodicidad: e?.tipo_de_nomina_empleado,
        fecha_final_nomina_mes: e?.fecha_final_nomina,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const getPermission = getModelPermission(
    timbradoNominaDetallePermission.permissionModel,
    timbradoNominaDetallePermission.catalogsModels,
    timbradoNominaDetallePermission.tabsModels,
    false,
  );

  const formInstances = [
    form,
  ];

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    const _data = await getNominasTimbrables(page, q);
    if (_data) {
      setData({ ..._data, results: formatReceivedClone(_data.results) });
    }
    setLoading(false);
  };

  const fetchPaginated = async (page = 1, q = null) => {
    setLoading(true);
    const response = await getNominasTimbrables(page, q);
    if (response) {
      setSelectedRowKeys([]);
      setData({ ...response, results: formatReceivedClone(response.results) });
    }
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estatusTimbrado,
        _estados,
        _tiposNominasEmpleados,
        _periodosNominasDetalles,
        _periodosFiscales,
        _periodosNominas,
        _data,
        _tiposDeNomina,
        _periodicidades,
        _subtiposDeNomina,
      ] = await Promise.all([
        getEstatusTimbrado(),
        getEstadosGlobales(),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getNominasTimbrables(),
        getTiposDeNomina(),
        getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getSubtiposNominas(),
      ]);
      if (mounted) {
        setEstatusTimbrado(_estatusTimbrado);
        setEstados(_estados);
        setTiposNominasEmpleados(_tiposNominasEmpleados);
        setPeriodosNominasDetalles(_periodosNominasDetalles);
        setPeriodosFiscales(_periodosFiscales);
        setPeriodosNominas(_periodosNominas);
        if (_data) {
          setData({ ..._data, results: formatReceivedClone(_data.results) });
        }
        setTiposDeNomina(_tiposDeNomina);
        setPeriodicidades(_periodicidades);
        setSubtiposDeNomina(_subtiposDeNomina);
        setLoading(false);
      }
    };
    fetchAll();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setEncabezado();
    setVisible(false);
    setErrores([]);
    setPeriodosFiltered([]);
    setPeriodo();
    setAplicaRetroactivo(false);
    setAplicaCalculoPorEmpleado(false);
    setEmpleadosDisponibles([]);
    form.resetFields();
  };

  const filterPeriodos = (_data) => {
    const {
      tipo_de_nomina_empleado,
      periodo_fiscal,
    } = form.getFieldsValue();

    const _periodo = periodo_fiscal || _data?.periodo_fiscal;
    const _tipo_nomina = tipo_de_nomina_empleado || _data?.tipo_de_nomina_empleado;

    const _periodosNominas = periodosNominas.filter(
      (e) => e.tipo_de_nomina_empleado === _tipo_nomina
      && e.periodo_fiscal === _periodo,
    );

    const _periodosDetallesFiltered = periodosNominasDetalles.filter(
      (e) => _periodosNominas.some(((x) => x.id === e.periodo_de_nomina)),
    );

    setPeriodosFiltered(_periodosDetallesFiltered);
  };

  const fetchEmpleadosDisponibles = async () => {
    const results = await getEmpleadosWithoutFilter({ estado_del_empleado: [2, 6, 3, 4, 5] });
    const all = Array.isArray(results) ? results : (results?.results || []);
    // eslint-disable-next-line max-len
    setEmpleadosDisponibles(all.sort((a, b) => Number(a.numero_de_empleado) - Number(b.numero_de_empleado)));
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);
    const _calculo = await getCalculoDeNomina(match.id);
    const _errores = await getNominasErrores({ nomina: _calculo?.id });
    setTimeout(() => {
      if (_calculo) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceivedClone(_calculo));
          setEncabezado(formatReceivedClone(_calculo));
          // eslint-disable-next-line max-len
          const nomina = tiposNominasEmpleados.find((e) => e.id === _calculo.tipo_de_nomina_empleado);
          setPeriodo(nomina?.periodicidad_de_pago);
          filterPeriodos(_calculo);
          setAplicaRetroactivo(_calculo.aplica_pago_de_retroactivo || false);
          setAplicaCalculoPorEmpleado(_calculo.aplica_calculo_por_empleado || false);
          if (_calculo.aplica_calculo_por_empleado) {
            fetchEmpleadosDisponibles();
          }
          setErrores(_errores);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };

      const saved = await postCalculosDeNominas(values);
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          setEncabezado(formatReceivedClone(saved));
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setEncabezado(formatReceivedClone(record));
    form.setFieldsValue(record);
  };

  const fetchEncabezado = async (id) => {
    const _calculo = await getCalculoDeNomina(id);
    setEncabezado(formatReceivedClone(_calculo));
    form.setFieldValue(_calculo);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickExportarExcel = async () => {
    const excel = await descargarExcel(selectedRowKeys[0]);
    if (excel) {
      const blob = new Blob([excel], {
        type: 'application/ms-excel',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'NominaPlazas.xls';
      link.click();
    }
  };

  const columns = [
    {
      titleText: 'Fecha',
      dataIndex: 'fecha_de_calculo',
      key: 'fecha_de_calculo',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'No. de Nómina',
      dataIndex: 'numero_nomina',
      key: 'numero_nomina',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (val) => tiposNominasEmpleados.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Tipo de Nómina',
      dataIndex: 'tipo_de_nomina',
      key: 'tipo_de_nomina',
      width: 200,
      render: (val) => tiposDeNomina.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Estatus de Timbrado',
      dataIndex: 'tipo_de_estatus_timbrado',
      key: 'tipo_de_estatus_timbrado',
      width: 200,
      render: (val) => <EstatusTimbradoTag id={val} catalogo={estatusTimbrado} />,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    descripcion: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  const onErrors = () => {
    setVisibleErrores(true);
  };

  const menuExportar = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Excel de Nómina',
          text: 'Excel de Nómina',
          icon: <FileExcelOutlined />,
          onClick: () => onClickExportarExcel(),
          disabledBySelection: true,
        },
      ]}
    />
  );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {modoPruebasTimbrado && (
          <Alert
            type="warning"
            showIcon
            message="Timbrado en Modo de Pruebas: los recibos se timbran con RFC de pruebas del SAT y no tienen validez fiscal."
            style={{ marginBottom: 10 }}
          />
        )}
        {!open ? (
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickEdit: () => onClickEdit(),
            }}
            customExportMenu={menuExportar}
            allowCustomExport
            editText="Detalle"
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Detalle' : null} Nómina`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                mutable={!selectedRowKeys.length}
                onCancel={onCancel}
                loading={loading}
                onErrors={errores.length ? onErrors : null}
              />
              )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_de_calculo"
                    label="Fecha"
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_nomina_empleado"
                    label="Tipo de Nómina Empleado"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      dataSource={tiposNominasEmpleados}
                      onChange={() => {
                        form.resetFields(['periodo_de_nomina_detalle', 'periodo_fiscal', 'dias_calculados']);
                        filterPeriodos();
                      }}
                      disabled={selectedRowKeys.length}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Periodicidad de Pago"
                    hasFeedback
                  >
                    <Select
                      dataSource={periodicidades}
                      value={periodo}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_nomina"
                    label="Tipo de Nómina"
                    hasFeedback
                  >
                    <Select
                      dataSource={tiposDeNomina}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="numero_nomina"
                    label="No. de Nómina"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo_fiscal"
                    label="Periodo Fiscal"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosFiscales}
                      disabled={selectedRowKeys.length}
                      onChange={() => {
                        form.resetFields(['periodo_de_nomina_detalle', 'dias_calculados']);
                        filterPeriodos();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo_de_nomina_detalle"
                    label="Periodo"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      keyProp="id"
                      labelProp="numero_de_nomina"
                      disabled={selectedRowKeys.length}
                      dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))}
                      render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
                      onChange={(val) => {
                        const _periodo = periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id));
                        const _diasCalculados = _periodo?.find((e) => e.id === val)?.no_de_dias;
                        form.setFieldValue('dias_calculados', _diasCalculados);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="dias_calculados"
                    label="No. de Días"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="folio_agrupador"
                    label="Folio Agrupador"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="subtipo_de_nomina"
                    label="Subtipo de Nómina Especial"
                  >
                    <Select
                      dataSource={subtiposDeNomina}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_pago_de_retroactivo"
                    label="Aplica Pago de Retroactivo"
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled
                    />
                  </Form.Item>
                </Col>
                {aplicaRetroactivo && (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="periodos_de_retroactivo"
                      label="Periodos de Retroactivo"
                      hasFeedback
                    >
                      <Select
                        mode="multiple"
                        keyProp="id"
                        disabled
                        dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))}
                        render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_calculo_por_empleado"
                    label="Aplica Cálculo por Empleado"
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled
                    />
                  </Form.Item>
                </Col>
                {aplicaCalculoPorEmpleado && (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="empleados_a_calcular"
                      label="Empleados a Calcular"
                      hasFeedback
                    >
                      <Select
                        mode="multiple"
                        keyProp="id"
                        disabled
                        dataSource={empleadosDisponibles}
                        render={(e) => e?.numero_y_nombre_completo || `${e?.numero_de_empleado || ''} - ${e?.nombre_completo || ''}`.trim()}
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estados}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="numero_plazas_calculadas"
                    label="Número de Empleados"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                {selectedRowKeys.length ? (
                  <>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Estatus de Timbrado">
                        <EstatusTimbradoTag id={encabezado?.tipo_de_estatus_timbrado} catalogo={estatusTimbrado} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Recibos Timbrados">
                        <Input
                          value={encabezado?.numero_plazas_timbradas ?? '—'}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Inicio de Timbrado">
                        <Input
                          value={formatearFechaHoraTimbrado(encabezado?.fecha_inicia_timbrado)}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Fin de Timbrado">
                        <Input
                          value={formatearFechaHoraTimbrado(encabezado?.fecha_final_timbrado)}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Duración del Timbrado">
                        <Input
                          value={encabezado?.tiempo_de_timbrado || '—'}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
              </Row>
              {selectedRowKeys.length
                // eslint-disable-next-line max-len
                ? (
                  <TimbradoNominaDetalle
                    permission={getPermission}
                    selected={selectedRowKeys[0]}
                    encabezado={encabezado}
                    onClickEdit={onClickEdit}
                    fetchData={fetchData}
                    fetchEncabezado={fetchEncabezado}
                    estatusTimbrado={estatusTimbrado}
                  />
                ) : null}
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
      </Spin>
      <Modal
        visible={visibleErrores}
        title={(
          <Row justify="space-between">
            <Text style={{ fontSize: '1.25rem' }}>
              Historial de Errores
            </Text>
            <ModalErroresControls
              onCancel={() => setVisibleErrores(false)}
            />
          </Row>
        )}
        footer={null}
        closable={false}
        width="85%"
      >
        <Table
          cols={[{
            titleText: 'Descripción de Error',
            dataIndex: 'error',
            key: 'error',
            width: 200,
          }]}
          data={errores}
          mobileColIndex={0}
        />
      </Modal>
    </Row>
  );
};

export default TimbradoNominas;
